(($, Drupal) => {
    Drupal.behaviors.switcherLabels = {
        attach: function attach() {
            $(".switcher__labels").once("switcher-labels").each(function() {
                const switcher = $(this);

                if (switcher.data('owl.carousel')._items.length > 2) {

                  switcher.on('changed.owl.carousel', function (event) {
                    const { index } = event.item;
                    const label = switcher.find(`.switcher__label-${index}`);

                    if (label && label.length) {
                      label.trigger('click');
                    }
                  });

                  switcher.addClass('with-nav');
                  switcher.find("." + sliderClasses.navContainerClass).addClass('default__nav');

                  switcher.data('owl.carousel').options.nav = true;
                  switcher.data('owl.carousel').options.items = 1;
                } else {
                  switcher.data('owl.carousel').options.items = 2;
                  switcher.data('owl.carousel').options.stagePadding = 30;
                }
                switcher.trigger('refresh.owl.carousel');
            });
        }
    };

})(jQuery, Drupal);
